import '../../assets/components/Context/globalstyles.css';const o = "_root_1m7m7_1", t = {
  root: o
};
export {
  t as default,
  o as root
};
